"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.statuses = void 0;
exports.statuses = {
    success: "SUCCESS",
    genericFailure: "GENERIC_FAILURE",
    invalidPassword: "INVALID_PASSWORD",
    expiredPassword: "EXPIRED_PASSWORD",
    poorPassword: "POOR_PASSWORD",
    breachedCredentials: "BREACHED_CREDENTIALS"
};
var identityCheck = function (tbd) {
    return tbd.id !== undefined;
};
var errorResponseCheck = function (tbd) {
    return tbd.message !== "" && tbd.status !== "";
};
var login = function (_a) {
    var servicesUrl = _a.servicesUrl, _b = _a.headers, headers = _b === void 0 ? undefined : _b, _c = _a.credentials, credentials = _c === void 0 ? "include" : _c;
    return __awaiter(void 0, void 0, void 0, function () {
        var response, parsed, ex_1;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch(servicesUrl + "/auth/login", {
                            credentials: credentials,
                            headers: headers,
                            method: "POST"
                        })];
                case 1:
                    response = _d.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    parsed = _d.sent();
                    if (response.ok && identityCheck(parsed)) {
                        return [2 /*return*/, {
                                status: exports.statuses.success,
                                identity: parsed
                            }];
                    }
                    if (response.status === 409 &&
                        errorResponseCheck(parsed) &&
                        parsed.errorCode === "EXPOSURE") {
                        return [2 /*return*/, {
                                status: exports.statuses.breachedCredentials,
                                message: "Login failed: " + parsed.message
                            }];
                    }
                    return [2 /*return*/, {
                            status: exports.statuses.genericFailure,
                            message: "Login failed."
                        }];
                case 3:
                    ex_1 = _d.sent();
                    return [2 /*return*/, {
                            status: exports.statuses.genericFailure,
                            message: "Login failed."
                        }];
                case 4: return [2 /*return*/];
            }
        });
    });
};
var userpassLogin = function (_a) {
    var username = _a.username, password = _a.password, servicesUrl = _a.servicesUrl, _b = _a.credentials, credentials = _b === void 0 ? "include" : _b;
    return __awaiter(void 0, void 0, void 0, function () {
        var headers, creds;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!username || !password) {
                        return [2 /*return*/, {
                                status: exports.statuses.genericFailure,
                                message: "Must supply username and password"
                            }];
                    }
                    headers = new Headers();
                    creds = window.btoa(username + ":" + password);
                    headers.set("Authorization", "Basic " + creds);
                    return [4 /*yield*/, login({ servicesUrl: servicesUrl, headers: headers, credentials: credentials })];
                case 1: return [2 /*return*/, _c.sent()];
            }
        });
    });
};
var agentTokenLogin = function (_a) {
    var agentToken = _a.agentToken, servicesUrl = _a.servicesUrl, _b = _a.credentials, credentials = _b === void 0 ? "include" : _b;
    return __awaiter(void 0, void 0, void 0, function () {
        var headers;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!agentToken) {
                        return [2 /*return*/, {
                                status: exports.statuses.genericFailure,
                                message: "Must supply AgentToken"
                            }];
                    }
                    headers = new Headers();
                    headers.set("Authorization", "AgentToken " + agentToken);
                    return [4 /*yield*/, login({ servicesUrl: servicesUrl, headers: headers, credentials: credentials })];
                case 1: return [2 /*return*/, _c.sent()];
            }
        });
    });
};
var Auth = /** @class */ (function () {
    function Auth(_a) {
        var _b = _a === void 0 ? { servicesUrl: "" } : _a, servicesUrl = _b.servicesUrl;
        this.servicesUrl = servicesUrl;
    }
    /**
     * Login user with credentials.
     * @param {string} username
     * @param {string} password
     */
    Auth.prototype.login = function (username, password) {
        return userpassLogin({
            username: username,
            password: password,
            servicesUrl: this.servicesUrl
        });
    };
    /**
     * Login user with provided AgentToken (SAML).
     * @param {string} agentToken
     */
    Auth.prototype.agentTokenLogin = function (agentToken) {
        return agentTokenLogin({
            agentToken: agentToken,
            servicesUrl: this.servicesUrl
        });
    };
    /**
     * testLogin user with credentials.
     * @param {string} username
     * @param {string} password
     */
    Auth.prototype.loginTest = function (username, password) {
        return userpassLogin({
            username: username,
            password: password,
            servicesUrl: this.servicesUrl,
            credentials: "omit"
        });
    };
    /**
     * testLogin user with agentToken.
     * @param {string} agentToken
     */
    Auth.prototype.agentTokenLoginTest = function (agentToken) {
        return agentTokenLogin({
            agentToken: agentToken,
            servicesUrl: this.servicesUrl,
            credentials: "omit"
        });
    };
    /**
     * Logout current user.
     */
    Auth.prototype.logout = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch(this.servicesUrl + "/auth/logout", {
                            credentials: "include",
                            method: "POST"
                        })
                            .then(function () {
                            return {
                                status: exports.statuses.success,
                                message: "Logout success"
                            };
                        })
                            .catch(function () {
                            return {
                                status: exports.statuses.genericFailure,
                                message: "Logout failed"
                            };
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Retrieves identity for the current session. Can be used
     *  to check whether a current session exists or is valid.
     */
    Auth.prototype.identify = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, parsed, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, fetch(this.servicesUrl + "/auth/info", {
                                credentials: "include"
                            })];
                    case 1:
                        response = _b.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        parsed = _b.sent();
                        if (response.ok && identityCheck(parsed)) {
                            return [2 /*return*/, {
                                    status: exports.statuses.success,
                                    identity: parsed
                                }];
                        }
                        return [2 /*return*/, {
                                status: exports.statuses.genericFailure,
                                message: "Identify request failed"
                            }];
                    case 3:
                        _a = _b.sent();
                        return [2 /*return*/, {
                                status: exports.statuses.genericFailure,
                                message: "Identify request failed"
                            }];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return Auth;
}());
exports.default = Auth;
